// extracted by mini-css-extract-plugin
module.exports = {"myDivStyle":"houseModal_myDivStyle__16YJ6","topDivStyle":"houseModal_topDivStyle__2vKkF"};